import { Button, Form, Modal, Popconfirm, Select, Typography } from 'antd';
import React from 'react';

const { Title } = Typography;
const { Option } = Select;

const CommunitiesEnrolment = ({
  isEnrolmentModalOpen,
  setIsEnrolmentModalOpen,
  isStatusLoading,
  enrollmentForm,
  onEnrollmentSubmit,
  communityList
}) => {
  return (
    <Modal
      visible={isEnrolmentModalOpen}
      onCancel={() => {
        enrollmentForm.resetFields();
        setIsEnrolmentModalOpen(false);
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            enrollmentForm.resetFields();
            setIsEnrolmentModalOpen(false);
          }}
          loading={isStatusLoading}>
          Close
        </Button>,
        <Popconfirm
          key="submit"
          title="Are you sure to submit?"
          onConfirm={() => enrollmentForm.submit()}
          okText="Yes"
          cancelText="No">
          <Button type="primary" loading={isStatusLoading}>
            Submit
          </Button>
        </Popconfirm>
      ]}
      centered>
      <Form
        form={enrollmentForm}
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 21 }}
        onFinish={onEnrollmentSubmit}>
        <Title level={4}>Manual Enrolment Form</Title>
        <Form.Item
          name="communityCode"
          label="Select Community"
          rules={[{ required: true }]}>
          <Select
            onChange={() => {}}
            placeholder="Select Community Code"
            showSearch={true}>
            {communityList?.map((option, index) => (
              <Option key={index} value={option?.value}>
                {option?.text}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="email"
          label="Enrollment Email(s)"
          extra="Enter required email and press enter to add them to the list."
          rules={[{ required: true }]}>
          <Select mode="tags" placeholder="Input Email(s)"></Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CommunitiesEnrolment;
